import { useCallback, useMemo } from "react";

import { normalize } from "../helpers/normalize";

import { useNetwork } from "./useNetwork";

export const useSelectedNetworkImportTypes = () => {
  const { selectedNetwork } = useNetwork();

  const getImportType = useCallback(() => selectedNetwork.importType, [
    normalize(selectedNetwork),
  ]);

  const getIsBy = useCallback((type: string | null) => selectedNetwork.importType === type, [
    normalize(selectedNetwork),
  ]);

  const isRms = useMemo(() => getIsBy("RMS"), [getIsBy]);
  const isOpen = useMemo(() => getIsBy("OPEN"), [getIsBy]);
  const isNull = useMemo(() => getIsBy(null), [getIsBy]);
  const isEntrata = useMemo(() => getIsBy("ENTRATA"), [getIsBy]);
  const isPasscode = useMemo(() => getIsBy("PASSCODE"), [getIsBy]);
  const isAcc = useMemo(() => getIsBy("ACC"), [getIsBy]);
  const isCbord = useMemo(() => getIsBy("CBORD"), [getIsBy]);
  const isRmbg = useMemo(() => getIsBy("RMBG"), [getIsBy]);
  const isSftp = useMemo(() => getIsBy("SFTP"), [getIsBy]);
  const isKinetic = useMemo(() => getIsBy("Kinetic"), [getIsBy]);
  const isEmail = useMemo(() => getIsBy("Email"), [getIsBy]);

  const isUniquePassCode = isRms || isCbord || isRmbg || isEntrata || isAcc || isKinetic;

  return {
    isOpen,
    isRms,
    isCbord,
    isAcc,
    isNull,
    isRmbg,
    isEntrata,
    isPasscode,
    isSftp,
    isKinetic,
    isEmail,
    isUniquePassCode,
    getImportType,
  };
};
